import { render, staticRenderFns } from "./PanelResumeSkills.vue?vue&type=template&id=6f89ee84&scoped=true&"
import script from "./PanelResumeSkills.vue?vue&type=script&lang=js&"
export * from "./PanelResumeSkills.vue?vue&type=script&lang=js&"
import style0 from "./PanelResumeSkills.vue?vue&type=style&index=0&id=6f89ee84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f89ee84",
  null
  
)

export default component.exports